import { React } from "react";

export function NoAlertComponent({ top, title }) {
  return (
    <div className="unstake__error__modal alert__midal" style={{ top: top }}>
      <p className="unstake__error__modal__title">{title}</p>
    </div>
  );
}
